import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import StorefrontTitle from "../shared/storefront-title.component";
import SorryBanner from "../../assets/img/imgEligibilitySorry.png";
import SpinnerTimeLoader from "../shared/timeLoading";
import storefront from "../../services/storefront.service";
import STF_CONSTANTS from "../../services/stfConstant.service";
import User from "../../services/user.service";
import Storage from "../../services/storage.service";
import Helpers from "../../helpers/shared.helper";
import CONSTANTS from "../../services/constants.service";
import PlanCardSingleAuto from "../storefront/planTab/plan-card-single-auto.component";
import EligibilityFailedPostpaidSkeleton from "../skeleton/eligibility_failed_postpaid.component";

const EligibilityFailedPostpaid = props => {

  const [planSuggestions, setPlanSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPrepaidPlanSuggestions = () => {
    setLoading(true);
    storefront
      .fetchPrepaidPlanSuggestions()
      .then((response) => {
        if (response) {
          // Fetch Prepaid Plan Suggestions
          setLoading(false);
          let data = response.data;
          if (data?.Cards?.length) {
            let sortedPlanSuggestionList = storefront.sortData(
              data?.Cards,
              "Order"
            );
            setPlanSuggestions(sortedPlanSuggestionList);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const checkCardType = (list, index) => {
    let content = "";
    if (list?.Shape === STF_CONSTANTS.HORIZONTAL_CARD) {
      // DO Nothing
    } else if (list?.Shape === STF_CONSTANTS.VERTICAL_CARD) {
      if (list?.CardList?.length) {
        list.CardList.forEach((ele) => {
          if (ele?.Type?.length) {
            switch (ele?.Type) {
              case STF_CONSTANTS.PREDEFINED_TYPE:
                content = (
                  <PlanCardSingleAuto
                    key={index}
                    planDetails={ele}
                    setLoading={setLoading}
                    eligibilityFailedPostpaid={true}
                  />
                );
                break;
              default:
                content = "";
                break;
            }
          }
        });
      }
    }

    return content;
  };

  const handlePostpaidRedirection = () => {
    // Here PlanSelected will be false from BE
    // Fetch Flow Status & Set the PC for Prepaid Plans
    // BE Need to remove the selected post paid plans and set the PlanSelected flow status as false.
    // FE need to set new the flow status postpaid_eligible to false 
    // FE need to updated the Product Codes to Regular
    props.toggleLoading(true);
    const regularProductCode = Helpers.getProductCode(CONSTANTS.REGULAR_PRODUCT_ATTR)
    // Storage.set("tempDisabledPlan", true, true);
    Storage.set("ActiveProductCodes", regularProductCode, true);
    Storage.clear("pre-defined-plan-selected");
    User.updateFlowStatus("postpaid_eligible", false).then(() => {
      User.fetchFlowStatus();
    }).catch(() => {
      props.toggleLoading(false);
    });
  }

  useEffect(() => {
    getPrepaidPlanSuggestions();
  }, [])

  let content = (
    <div className="stf-eligibility-cntnr stf-eligibility-cntnr-margin stf-eligibility-failed-postpaid">
      <img src={SorryBanner} alt=""/>
      <StorefrontTitle
        title={Translations.keys["stm_postpaid_ineligibile_title"]}
        desc={Translations.keys["stm_postpaid_ineligibile_desc"]}
      />
      {loading ? <EligibilityFailedPostpaidSkeleton /> :
      <>
        <div className="eligibility-plan-card-container">
          {planSuggestions?.length ? 
          <>
            {planSuggestions?.map((planDetails, index) =>
              <React.Fragment key={"cards" + index}>
                {checkCardType(planDetails, index)}
              </React.Fragment>
            )}
          </> :
          ""
          }
        </div>
        <button className={"common-button"} onClick={handlePostpaidRedirection}>{Translations.keys["stm_see_all_prepaid_plans"]}</button>
      </>}
    </div>

  );
  if (props.loading) {
    content = <SpinnerTimeLoader />
  }
  return content;
};
export default EligibilityFailedPostpaid;
